import React, { useRef, useEffect, useState } from "react";
import { Button, Tooltip } from "antd";
import { ReloadOutlined } from "@ant-design/icons";

const Captcha = ({ onChange }) => {
  const canvasRef = useRef(null);
  const [value, setValue] = useState("");

  const generateCaptchaText = () => {
    const chars = "ABCDEFGHJKLMNPQRSTUVWXYZ23456789";
    let text = "";
    for (let i = 0; i < 5; i++) {
      text += chars[Math.floor(Math.random() * chars.length)];
    }
    return text;
  };

  const drawCaptcha = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const captchaText = generateCaptchaText();
    setValue(captchaText);
    onChange(captchaText);

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    // Background
    ctx.fillStyle = "#f7f7f7";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Noise dots
    for (let i = 0; i < 100; i++) {
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.15})`;
      ctx.beginPath();
      ctx.arc(
        Math.random() * canvas.width,
        Math.random() * canvas.height,
        1,
        0,
        Math.PI * 2
      );
      ctx.fill();
    }

    // Random lines
    for (let i = 0; i < 4; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.2})`;
      ctx.lineWidth = 1;
      ctx.stroke();
    }

    // Text
    ctx.font = "28px Verdana";
    ctx.textBaseline = "middle";
    ctx.textAlign = "center";

    const xStart = 25;

    captchaText.split("").forEach((char, i) => {
      const x = xStart + i * 22;
      const y = canvas.height / 2 + (Math.random() * 8 - 4);
      const rotation = (Math.random() - 0.5) * 0.5;

      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rotation);
      ctx.transform(1, Math.random() * 0.3, 0, 1, 0, 0);

      ctx.fillStyle = `rgb(${50 + Math.random() * 100}, ${50 + Math.random() * 50}, ${50 + Math.random() * 50})`;
      ctx.fillText(char, 0, 0);
      ctx.restore();
    });
  };

  useEffect(() => {
    drawCaptcha();
  }, []);

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: 12 }}>
      <canvas
        ref={canvasRef}
        width={150}
        height={50}
        style={{
          border: "1px solid #d9d9d9",
          borderRadius: "8px",
          background: "#fff",
          boxShadow: "0 2px 6px rgba(0,0,0,0.06)"
        }}
      />

      <Tooltip title="دریافت کد جدید">
        <Button
          type="default"
          shape="circle"
          icon={<ReloadOutlined />}
          onClick={drawCaptcha}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 6px rgba(0,0,0,0.08)"
          }}
        />
      </Tooltip>
    </div>
  );
};

export default Captcha;
